import styled from 'styled-components';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

import { backgroundImage } from '@nubank/www-latam-commons/components/Image/Image';
import ProductPageOpenFormSection from 'patterns/ProductPageOpenFormSection/ProductPageOpenFormSection';

export const StyledProductPageOpenFormSection = styled(ProductPageOpenFormSection)`
  background-color: ${nuDSColor('primary')};
  background-size: cover;
  background-position: center center;
  ${backgroundImage({
    xs: {
      '1x': 'people-smile-at-home/people-smile-at-home-xs@1x.jpg',
      '2x': 'people-smile-at-home/people-smile-at-home-xs@2x.jpg',
      '3x': 'people-smile-at-home/people-smile-at-home-xs@3x.jpg',
    },
    md: {
      '1x': 'people-smile-at-home/people-smile-at-home-md@1x.jpg',
      '2x': 'people-smile-at-home/people-smile-at-home-md@2x.jpg',
      '3x': 'people-smile-at-home/people-smile-at-home-md@3x.jpg',
    },
    lg: {
      '1x': 'people-smile-at-home/people-smile-at-home-lg@1x.jpg',
      '2x': 'people-smile-at-home/people-smile-at-home-lg@2x.jpg',
      '3x': 'people-smile-at-home/people-smile-at-home-lg@3x.jpg',
    },
  })};
`;

StyledProductPageOpenFormSection.displayName = 'StyledProductPageOpenFormSection';
